import React from 'react';

import { ReserveChangeRequestDynamicContainer } from '~/components/exposures/ReserveChangeRequestContainer';
import { ApprovalPaymentIcon } from '~/components/icons';
import InlineIconButton from '~/components/InlineIconButton';
import type { ReserveChangeRequestForApprovals } from '~/components/types/finances-types';

const ReserveChangeRequestActionCell: React.FC<{
  row: ReserveChangeRequestForApprovals;
  onReloadFinances: () => void;
}> = ({ row, onReloadFinances }) => {
  const [isDialogOpen, setIsDialogOpen] = React.useState(false);
  return (
    <div className="flex items-center justify-center">
      <>
        <InlineIconButton
          icon={ApprovalPaymentIcon}
          onClick={() => setIsDialogOpen(true)}
          tooltipTitle="Payment Request"
        />
        {isDialogOpen && (
          <ReserveChangeRequestDynamicContainer
            claimId={row.claim_id}
            exposureId={row.exposure_id ?? 0}
            payableWithReserveId={row.payable_with_reserve_id}
            reserveChangeRequest={row}
            cardDialogProps={{
              maxWidth: 'sm',
              fullWidth: true,
              isDialog: true,
            }}
            onClose={() => setIsDialogOpen(false)}
            onUpdate={onReloadFinances}
            refreshInBackground
          />
        )}
      </>
    </div>
  );
};

export default ReserveChangeRequestActionCell;
